<template>
<div class="container index-page">
    <v-head></v-head>
    <v-left current="index"></v-left>
    <div>
        <div v-if="loading" class="my-loading"><i class="el-icon-loading"></i></div>
        <div v-else class="count-dic">
          <div>Welcome!</div>
            <!-- <div class="ind-block">
                <ul class="c-ul" v-if="statics">
                    <li class="item relative" v-for="(c,index_c) in statics.times" :key="index_c">
                        <span class="date">{{c.title}}</span>
                        <div class="font-s-24"><span style="font-size:16px;color:#999">¥</span> {{c.statics.order_payed.amount_total}}</div>
                        <div class="bottom-cdxx clearfix gray-color">
                            <div class="fl">
                                <span style="margin-right:10px;">总数 {{c.statics.order_all.count}}</span>
                                <span>未付款 {{c.statics.order_unpayed.count}}</span>
                            </div>
                            <div class="fr">
                                <span>退款 ¥{{c.statics.order_refund.amount_refund}}</span>
                            </div>
                        </div>
                    </li>
                </ul>            
            </div>
            <div class="ind-block">
                <chart></chart>
            </div> -->
        </div>
    </div>
</div>
</template>
<script>
import head from '@/pages/public/_head'
import left from '@/pages/public/_left'
import chart from '@/pages/index/_chart'
export default {
    components:{
        'v-head':head,
        'v-left':left,
        'chart':chart,
    },
    data(){
        return {
            loading:false,
            statics:null,
        }
    },
    methods:{
        getStatics(){
            this.loading = true;
            this.$http.post('/v1/pri/onboard/count-items', {})
            .then( (response) => {
                var res = response.data;
                if (res.code == 1) {
                    this.statics = res.data
                }
                this.loading = false;
            })            
        },
    },
    mounted(){
        this.getStatics()
    },
}
</script>
<style scoped>
.index-page {background-color:rgb(244,244,244)}
.index-page .ind-block{background-color: #fff;margin-bottom: 20px;padding:10px;box-sizing: border-box;}
.index-page .count-dic .c-ul{display: flex; flex-direction:row;}
.index-page .count-dic .c-ul li.item{margin: 10px;text-align: center;border:1px solid #dfdfdf;box-shadow: 1px 1px 3px #efefef;flex: 1;padding:10px;box-sizing: border-box;border-radius: 5px;}
.index-page .count-dic .c-ul li.item .font-s-24{margin: 64px auto;font-size: 30px;font-weight: bold;color: #666;}
.index-page .count-dic .c-ul li.item .date{position: absolute;left: 10px;top: 10px;}
.index-page .count-dic .c-ul li.item .bottom-cdxx{position: absolute;left: 10px;bottom: 0;right: 10px;line-height: 44px;height: 44px;}
</style>



// WEBPACK FOOTER //
// src/pages/index/Index.vue